import { render, staticRenderFns } from "./TwocolumnRow.vue?vue&type=template&id=7f619505&scoped=true&"
import script from "./TwocolumnRow.vue?vue&type=script&lang=js&"
export * from "./TwocolumnRow.vue?vue&type=script&lang=js&"
import style0 from "./TwocolumnRow.vue?vue&type=style&index=0&id=7f619505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f619505",
  null
  
)

export default component.exports